export type QuinnRouteDescription = {
    label: string;
    suggestions: string[];
};

const ROUTE_DESCRIPTIONS: Array<{ test: RegExp; description: QuinnRouteDescription }> = [
    {
        test: /^\/transactions/,
        description: {
            label: "Transacties",
            suggestions: [
                "Welke transacties zijn deze maand niet gecategoriseerd?",
                "Toon de grootste uitgaven van deze maand in een tabel",
                "Welke klanten gaven meer uit dan vorige maand?",
            ],
        },
    },
    {
        test: /^\/documents/,
        description: {
            label: "Documenten",
            suggestions: [
                "Welke documenten missen nog een koppeling?",
                "Zoek facturen van Groothandel Noord",
                "Hoeveel bonnen zijn er deze maand geüpload?",
            ],
        },
    },
    {
        test: /^\/unmatched-transactions/,
        description: {
            label: "Vraagposten",
            suggestions: [
                "Waarom staan deze transacties open?",
                "Welke vraagposten zijn ouder dan 60 dagen?",
                "Vat de openstaande posten samen per klant",
            ],
        },
    },
    {
        test: /^\/matches/,
        description: {
            label: "Matches",
            suggestions: [
                "Welke matches hebben een afwijkend bedrag?",
                "Toon dubbele betalingen van deze maand",
                "Hoeveel facturen zijn automatisch gematcht?",
            ],
        },
    },
    {
        test: /^\/client-insights/,
        description: {
            label: "Klantinzichten",
            suggestions: [
                "Vat de belangrijkste signalen voor deze klant samen",
                "Hoe ontwikkelt de cashflow zich?",
                "Welke kosten stijgen het hardst?",
            ],
        },
    },
    {
        test: /^\/business\//,
        description: {
            label: "Klantinstellingen",
            suggestions: [
                "Wat is er deze maand veranderd bij deze klant?",
                "Toon de openstaande facturen van deze klant",
                "Hoe staat het met de btw-aangifte?",
            ],
        },
    },
];

const DEFAULT_DESCRIPTION: QuinnRouteDescription = {
    label: "Overzicht",
    suggestions: [
        "Aan welke leveranciers is deze maand meer uitgegeven dan vorige maand?",
        "Toon de openstaande facturen ouder dan 60 dagen",
        "Geef een cashflowprognose voor de komende zes maanden",
    ],
};

export function describeRoute(pathname: string): QuinnRouteDescription {
    const match = ROUTE_DESCRIPTIONS.find((entry) => entry.test.test(pathname));
    return match ? match.description : DEFAULT_DESCRIPTION;
}
